var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.292486 9.4625L4.17249 5.5825L0.292486 1.7025C0.105233 1.51567 0 1.26202 0 0.9975C0 0.732982 0.105233 0.479331 0.292486 0.2925C0.682486 -0.0975 1.31249 -0.0975 1.70249 0.2925L6.29249 4.8825C6.68249 5.2725 6.68249 5.9025 6.29249 6.2925L1.70249 10.8825C1.31249 11.2725 0.682486 11.2725 0.292486 10.8825C-0.0875144 10.4925 -0.0975144 9.8525 0.292486 9.4625Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/Icon2.461cb4a99517add79bac74a0903c2c2b.svg";
export { ForwardRef as ReactComponent };